import type { BoxTier, PremiumItem, PriceBreakdown } from "./types";

export function formatUsd(cents: number): string {
  const dollars = cents / 100;
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(dollars);
}

export function calculateBreakdown(
  tier: BoxTier | undefined,
  selectedPremiumIds: number[],
  premiumCatalog: PremiumItem[],
): PriceBreakdown {
  const basePriceCents = tier?.basePriceCents ?? 0;
  const premiumCents = selectedPremiumIds.reduce((sum, id) => {
    const p = premiumCatalog.find((x) => x.id === id);
    return sum + (p?.surchargeCents ?? 0);
  }, 0);
  return {
    basePriceCents,
    premiumCents,
    totalCents: basePriceCents + premiumCents,
  };
}

export function countSelectedItems(items: Record<number, number>): number {
  return Object.values(items).reduce((a, b) => a + b, 0);
}
